<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.1562 9.375H9.54171V7.25C9.54171 5.68738 10.8124 4.41671 12.375 4.41671C13.9376 4.41671 15.2083 5.68738 15.2083 7.25C15.2083 7.64104 15.525 7.95829 15.9167 7.95829C16.3084 7.95829 16.625 7.64104 16.625 7.25C16.625 4.90607 14.7189 3 12.375 3C10.0311 3 8.125 4.90607 8.125 7.25V9.375H7.59375C6.71542 9.375 6 10.0896 6 10.9688V18.4062C6 19.2854 6.71542 20 7.59375 20H17.1562C18.0346 20 18.75 19.2854 18.75 18.4062V10.9688C18.75 10.0896 18.0346 9.375 17.1562 9.375Z"
      fill="currentColor"
    />
  </svg>
</template>
